export default __webpack_public_path__ + "static/media/myanmar2015A.c4a6e5cc.jpg";